<template>
  <div>
    <div class="detail-info subdivide life">
      <div>
        <span class="info-key">体温：</span>
        <div>
          <el-input
            v-model="form.temperature"
            class="radio-groups"
            placeholder=""
          />
          <span class="info-key unit">℃</span>
        </div>
      </div>
      <div>
        <span class="info-key">呼吸：</span>
        <div>
          <el-input
            v-model="form.breath"
            class="radio-groups"
            placeholder=""
          />
          <span class="info-key unit">次/分</span>
        </div>
      </div>
      <div>
        <span class="info-key">收缩压：</span>
        <div>
          <el-input
            v-model="form.systolicPressure"
            class="radio-groups"
            placeholder=""
          />
          <span class="info-key unit">mmHg</span>
        </div>
      </div>
      <div>
        <span class="info-key">舒张压：</span>
        <div>
          <el-input
            v-model="form.diastolicPressure"
            class="radio-groups"
            placeholder=""
          />
          <span class="info-key unit">mmHg</span>
        </div>
      </div>
      <div>
        <span class="info-key">血糖：</span>
        <div>
          <el-input
            v-model="form.bloodSuger"
            class="radio-groups"
            placeholder=""
          />
          <span class="info-key unit">mmol/l </span>
        </div>
      </div>
    </div>
    <div class="detail-info subdivide">
      <div class="info-title">意识状态：</div>
      <el-radio
        v-model="form.awareness"
        label="清醒"
        class="consciousness-radio"
      >清醒
      </el-radio>
      <el-radio
        v-model="form.awareness"
        label="嗜睡"
      >嗜睡
      </el-radio>
      <el-radio
        v-model="form.awareness"
        label="模糊"
      >模糊
      </el-radio>
      <el-radio
        v-model="form.awareness"
        label="浅昏迷"
      >浅昏迷
      </el-radio>
      <el-radio
        v-model="form.awareness"
        label="深昏迷"
      >深昏迷
      </el-radio>
      <el-radio
        v-model="form.awareness"
        label="错乱"
      >错乱
      </el-radio>
    </div>
    <div class="detail-info subdivide particular">
      <div class="info-title">瞳孔：</div>
      <el-radio v-model="form.pupil" label="反射" class="reflex-radio">反射</el-radio>
      <el-radio v-model="form.pupil" label="迟钝">迟钝</el-radio>
      <el-radio v-model="form.pupil" label="消失">消失</el-radio>
    </div>
    <div class="detail-info">
      <span class="info-title">病情分级：</span>
      <four-level
        :level="patient.illness_level"
        @setNewLevel="setNewLevel"
      />
    </div>
    <div class="detail-info">
      <span class="info-title">初诊：</span>
      <el-input
        v-model="form.fistCheck"
        class="diagnosed"
        placeholder=""
      />
    </div>
    <div class="detail-info description-detail">
      <span class="info-title description">详细描述：</span>
      <el-input
        v-model="form.details"
        class="description"
        placeholder=""
        type="textarea"
        resize="none"
        :rows="6"
      />
    </div>
  </div>
</template>

<script>
import FourLevel from "@components/common/FourLevel";
import { mapState } from "vuex";

export default {
  name: "SituationEdit",
  components: { FourLevel },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),
  },
  watch: {
    patient: {
      handler(val) {
        this.form = {
          ...val,
          method: "changeMedicalhistory"
        };
      },
      immediate: true
    }
  },

  methods: {
    setNewLevel(val) {
      this.form.illness_level = val;
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-input__inner {
  width: 80px;
  height: 32px;
  border: 1px solid #999999;
  border-radius: 10px;
}

.info-key.unit {
  margin-left: 13px;
}

.el-input {
  width: auto;
  margin-left: 24px;
}

.injury-input {
  width: 399px;
  border-width: 1px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-color: #0c618b;
  color: #333;
  background: #fff;
  outline: none;
  font-size: 18px;
}

.diagnosed ::v-deep {
  margin-left: 0;

  .el-input__inner {
    width: 300px;
  }
}

.el-textarea.description {
  width: 640px;
  border-radius: 10px;
}

.description-detail {
  height: auto;
  margin-top: 12px;
}

.info-title.description {
  vertical-align: top;
  line-height: initial;
}
</style>
